import React from 'react';
import CardSection from '../../Shared/CardSection';
import Tooltip from '../../Shared/Tooltip';

const HealthValuesSection = ({ model, portalSettings }) => {

    const {
        polType,
        productName,
        productType,
        plan,
        statusDesc,
        issueDate,
        termDate,
        qualType,
        monthlyPremium,
        quarterlyPremium,
        semiAnnualPremium,
        annualPremium
    } = model.policyInfo;

    const mode = model.policyInfo.mode;

    const coverageType = model?.policyInfo?.typeOfCoverage === 'Indemnity' ? 'Hospital Indemnity' : model?.policyInfo?.typeOfCoverage;

    const birthDate = new Date(model?.policyInfo?.birthDate);
    const today = new Date();

    const age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    const dayDiff = today.getDate() - birthDate.getDate();

    const finalAge =
        monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)
            ? age - 1
            : age;


    const premiumMap = {
        1: { label: 'Monthly Premium', value: monthlyPremium },
        3: { label: 'Quarterly Premium', value: quarterlyPremium },
        6: { label: 'Semi-Annual Premium', value: semiAnnualPremium },
        12: { label: 'Annual Premium', value: annualPremium }
    };

    const selectedPremium = premiumMap[mode] || { label: 'Unknown', value: 0 };

    // Build tooltip content with all *except* selected
    const tooltipContent = Object.entries(premiumMap)
        .filter(([key]) => parseInt(key) !== mode)
        .map(([_, info]) => `${info.label}: ${info.value}`)
        .join('\n');

    return (
        <div className="container container-section custom-width" id="values-container">

            {/* Top Row: Premium Card */}
            <div className="flex-row">
                <div className="policy-card small-card">
                    <div className="card">
                        <div className="card-body premium-card-body">
                            <div className="premium-header">
                                <h6>{selectedPremium.label}
                                    <Tooltip text={tooltipContent} />
                                </h6>
                            </div>

                            <h3 className="bold value">{selectedPremium.value}</h3>
                        </div>
                    </div>
                </div>
                
                {/*Removed per Taylor/Andelyn 2026/09/14*/}
                {/*<div className="policy-card small-card">*/}
                {/*    <div className="card">*/}
                {/*        <div className="card-body premium-card-body">*/}
                {/*            <div className="premium-header">*/}
                {/*                <h6>Total Premiums Paid</h6>*/}
                {/*            </div>*/}

                {/*            <h3 className="bold value">{model.policyInfo.premiumSumDisplay}</h3>*/}
                {/*        </div>*/}
                {/*    </div>*/}
                {/*</div>*/}
            </div>

            {/* Second Row: Card Sections */}
            <div className="flex-row">
                <CardSection
                    title="Contract Details"
                    blocks={[
                        { label: "Plan:", value: model.policyInfo.productType  },
                        { label: "Coverage Type:", value: coverageType },
                        { label: "Billing Method:", value: model.policyInfo.billingMethod },
                        { label: "Issue Date:", value: model.policyInfo.issueDate },
                        { label: "Paid To Date:", value: model.policyInfo.paidToDate }
                    ]}
                />
                <CardSection
                    title="Insured Info"
                    blocks={[
                        { label: "Name:", value: model.insured.displayName },
                        { label: "Age:", value: finalAge },
                        { label: "Gender:", value: model.policyInfo.sex },
                        { label: "Birthday:", value: model.policyInfo.birthDate },
                        { label: "Phone:", value: model.insured.phone },
                        { label: "Email:", value: model.insured.email },
                        { label: "Issue State:", value: model.policyInfo.issueState }
                    ]}
                />
            </div>
        </div>
    );
};

export default HealthValuesSection;
